import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\LinkGroup\StoreContactController::__invoke
* @see app/Http/Controllers/LinkGroup/StoreContactController.php:28
* @route '/link-groups/{linkGroup}/contacts'
*/
export const store = (args: { linkGroup: string | { id: string } } | [linkGroup: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/link-groups/{linkGroup}/contacts',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\LinkGroup\StoreContactController::__invoke
* @see app/Http/Controllers/LinkGroup/StoreContactController.php:28
* @route '/link-groups/{linkGroup}/contacts'
*/
store.url = (args: { linkGroup: string | { id: string } } | [linkGroup: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { linkGroup: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { linkGroup: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            linkGroup: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        linkGroup: typeof args.linkGroup === 'object'
        ? args.linkGroup.id
        : args.linkGroup,
    }

    return store.definition.url
            .replace('{linkGroup}', parsedArgs.linkGroup.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\LinkGroup\StoreContactController::__invoke
* @see app/Http/Controllers/LinkGroup/StoreContactController.php:28
* @route '/link-groups/{linkGroup}/contacts'
*/
store.post = (args: { linkGroup: string | { id: string } } | [linkGroup: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

const contacts = {
    store: Object.assign(store, store),
}

export default contacts